module.exports = __webpack_public_path__ + "img/overview_get_involved.f6d3323a.svg";